import { ecgConversionFactor } from '@cardiacsense/cs-charts-module';
export const fakeEcgDataForProportionSign = (scale, fwVersion) => {
    const ecgConv = fwVersion ? ecgConversionFactor(fwVersion) : 0.0033;
    const h = scale === 1 ? 10000 + 2 / ecgConv : 11000;
    const fakeEcg = [];
    let fake = 0;
    for (let s = 0; s < 256; s++) {
        if (s === (11 * scale))
            fake = 10000;
        if (s === (26 * scale) - 1)
            fake = h;
        if (s === (51 * scale))
            fake = 10000;
        if (s === (65 * scale))
            fake = 0;
        fakeEcg.push(fake);
    }
    const empty256 = Array(256).fill('');
    const sign = {
        series: 0,
        ecg: fakeEcg,
        ecgPeaks: empty256,
        ecgPeakTypes: empty256,
        ecgHr: empty256,
        ecgNextHr: empty256
    };
    return sign;
};
const convertToCamelCase = (str) => str.replace(/_[a-z]/g, (match) => `${match[1].toUpperCase()}`);
export const convertKeysToCamelCase = (obj) => {
    const res = {};
    Object.keys(obj).forEach(key => {
        res[convertToCamelCase(key)] = obj[key];
    });
    return res;
};
export const convertConfigurationsToBooleans = (app_config, compareConfig = 'off') => {
    const default_config = {
        pulse_rate: true,
        ppg_af: true,
        heart_rate: true,
        ecg_af: true,
        blood_pressure: true,
        weight: true,
        glucose: true,
        spo2: true,
        respiratory_rate: true,
        body_temp: true,
        pwv: true,
        hrv_pr: true,
        hrv_lfhf: true,
        sleep: true,
        steps: true,
        calories: true,
    };
    let app_configuration_config = Object.assign({}, default_config);
    if (!app_config) {
        return default_config;
    }
    else {
        if (app_config.measurements) {
            const measurements = app_config.measurements;
            const measurements_config = {
                heart_rate: measurements.heart_rate !== compareConfig,
                body_temp: measurements.body_temp !== compareConfig,
                pulse_rate: measurements.pulse_rate !== compareConfig,
                respiratory_rate: measurements.respiratory_rate !== compareConfig,
                spo2: measurements.spo2 !== compareConfig,
                glucose: measurements.glucose !== compareConfig,
                weight: measurements.weight !== compareConfig,
                blood_pressure: measurements.blood_pressure !== compareConfig,
                pwv: measurements.pwv !== compareConfig,
                hrv_pr: measurements.hrv_pr !== compareConfig,
                hrv_lfhf: measurements.hrv_lfhf !== compareConfig,
                sleep: measurements.sleep !== compareConfig,
                steps: measurements.steps !== compareConfig,
                calories: measurements.calories !== compareConfig
            };
            app_configuration_config = Object.assign(Object.assign({}, app_configuration_config), measurements_config);
        }
        if (app_config.alerts) {
            const alerts = app_config.alerts;
            const alerts_config = {
                ppg_af: alerts.af !== compareConfig,
                ecg_af: alerts.af !== compareConfig,
            };
            app_configuration_config = Object.assign(Object.assign({}, app_configuration_config), alerts_config);
        }
    }
    return app_configuration_config;
};
export const isNode = (e) => {
    return (typeof Node === "object" ? e instanceof Node :
        e && typeof e === "object" && typeof e.nodeType === "number" && typeof e.nodeName === "string");
};
export const fixNum = (num, toFix) => {
    if (isNaN(num))
        return num;
    const deleteZeros = Array(toFix).fill(0).join('');
    let fixedNumber = num.toFixed(toFix);
    fixedNumber = Number((`${fixedNumber}`).replace(`.${deleteZeros}`, ''));
    return fixedNumber;
};
